import { format, isValid, parseISO } from 'date-fns'

export function DateFormat(date) {
    const parse = parseISO(date);
        if(!isValid(parse))
          return "";
    
        return format(parse, 'dd/MM/yyyy HH:mm:ss');
}